/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { apiKeysUpdate } from "../../funcs/apiKeysUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PutApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$inboundSchema,
};

export const tool$apiKeysUpdate: ToolDefinition<typeof args> = {
  name: "api-keys_update",
  description: `Update API key

Updates an existing API key&#x27;s configuration`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await apiKeysUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
